import React from "react";
import { Button } from "./ui/button";

const ExperienceSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        
        {/* Two-Column Header Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-16">
          {/* Left Column - Big Two-Line Text */}
          <div>
            <h2 className="text-gray-900 leading-tight">
              <span 
                style={{
                  fontFamily: 'Caslon540Std, serif',
                  fontSize: '40px',
                  fontStyle: 'italic',
                  fontWeight: '500',
                  height: '44px',
                  flexBasis: '83.3333%',
                  display: 'block',
                  color: 'rgb(17, 24, 39)'
                }}
              >
                The Ritz-Carlton
              </span>
              <span 
                style={{
                  fontFamily: 'Caslon540Std, serif',
                  fontSize: '3.75rem', // --t-display-s-font-size-viewport-l
                  lineHeight: '4.125rem', // --t-display-s-line-height-viewport-l
                  fontWeight: '400', // --t-display-s-font-weight
                  letterSpacing: '0', // --t-display-s-letter-space
                  fontStyle: 'normal', // --t-display-s-font-style
                  textTransform: 'uppercase', // --t-display-s-text-transform
                  color: 'rgb(17, 24, 39)',
                  display: 'block'
                }}
              >
                Experience
              </span>
            </h2>
          </div>

          {/* Right Column - Paragraph and Button */}
          <div className="space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              At The Ritz-Carlton, we believe that travel is an opportunity to create memories that will last a lifetime. Through our legendary service, thoughtful amenities and commitment to craft, we inspire life's most meaningful moments, each and every day.
            </p>
            
            <Button
              className="bg-transparent border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white px-8 py-3 text-sm font-medium transition-colors duration-200 rounded-none"
              style={{ 
                fontFamily: 'Swiss-721, Arial, sans-serif',
                fontSize: '0.8125rem',
                fontWeight: 700,
                letterSpacing: '0.5px'
              }}
            >
              Explore The Ritz-Carlton Experience
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;

